import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';
import { userTypeOptions } from '../../../utils/constants';
import Select from 'react-select';



const TaskCreate = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState('');
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState('');
  const [taskDetail, setTaskDetail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
   

    axios
      .get(`${process.env.REACT_APP_WEB_SERVICES_URL}/manager/get-master-tasks`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status) setTasks(res.data.tasks);
      })
      .catch((err) => globalErrorHandler(err, navigate));
  }, [navigate]);


    useEffect(() => {
      if (userType) {
  
         axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/manager/get-guest-by-role-by-property`, { role: userType},{
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status) setUsers(res.data.guests);
        })
        .catch((err) => globalErrorHandler(err, navigate));
  
       
      }
    }, [userType, navigate]);

  useEffect(() => {
    if (userType) {
      const filtered = users.filter((u) => u.role === userType);
      setFilteredUsers(filtered);
      setSelectedUser('');
    }
  }, [userType, users]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!userType || !selectedUser || !dateTime || !selectedTask ) {
      Swal.fire("User Type, User, Date and Time and Task are required!", '', 'warning');
      return;
    }

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/manager/create-task`,
        {
          user_type: userType,
          guest_id: selectedUser,
          task_date_time: dateTime,
          task_id: selectedTask,
          task_detail: taskDetail,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.status) {
          Swal.fire("Success", res.data.message, "success");
          setUserType('');
          setSelectedUser('');
          setDateTime('');
          setSelectedTask('');
          setTaskDetail('');
        } else {
          Swal.fire("Error", res.data.message, "error");
        }
      })
      .catch((err) => globalErrorHandler(err, navigate))
      .finally(() => setLoading(false));
  };

  return (
    <div className="container-fluid mt-4">
                    <h3 className="mb-4">Create New Task</h3>

      <Card className="shadow">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="userType" className="mb-3">
              <Form.Label>Select User Type <span className='text-danger'>*</span></Form.Label>
              <Form.Select value={userType} onChange={(e) => setUserType(e.target.value)}>
                <option value="">-- Select --</option>
                {userTypeOptions.map((opt) => (
                  <option key={opt.role} value={opt.role}>{opt.label}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Row className="mb-3">
              <Col md={4}>
               



                <Form.Group controlId="userSelect">
                  <Form.Label>
                    Select User <span className="text-danger">*</span>
                  </Form.Label>

                  <Select
                    options={filteredUsers.map((user) => ({
                      value: user.id,
                      label: `${user.name} (${user.email})`,
                    }))}
                    value={
                      selectedUser
                        ? {
                          value: selectedUser,
                          label: `${filteredUsers.find(u => u.id === selectedUser)?.name} (${filteredUsers.find(u => u.id === selectedUser)?.email})`,
                        }
                        : null
                    }
                    onChange={(selected) => setSelectedUser(selected?.value)}
                    placeholder="-- Select --"
                    isClearable
                  />
                </Form.Group>


               
              </Col>

              <Col md={4}>
                <Form.Group controlId="dateTime">
                  <Form.Label>Date and Time <span className='text-danger'>*</span></Form.Label>
                  <Flatpickr
                    className="form-control"
                    data-enable-time
                    value={dateTime}
                    onChange={(date) => setDateTime(date[0])}
                    options={{ dateFormat: "Y-m-d H:i" }}
                    placeholder="Select Date & Time"
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="taskSelect">
                  <Form.Label>Select Task <span className='text-danger'>*</span></Form.Label>
                  <Form.Select value={selectedTask} onChange={(e) => setSelectedTask(e.target.value)}>
                    <option value="">-- Select --</option>
                    {tasks.map((task) => (
                      <option key={task.id} value={task.id}>{task.task}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="taskDetail" className="mb-3">
              <Form.Label>Enter Task Detail</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={taskDetail}
                onChange={(e) => setTaskDetail(e.target.value)}
              />
            </Form.Group>

            <div className="text-end">
              <Button type="submit" variant="primary" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  "Save Task"
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TaskCreate;
